import * as Moment from 'moment'

export const Indexes = {
  Advertisements: 'advertisements',
  CommunityPersonActionRollup: 'community-person-action-rollup',
  EmailActions: 'email-events',
  IntegrationRuns: 'idx.integration-runs',
  MessageRunDetails: 'message-run-details',
  Tags: 'tags',
  TopClicks: {
    EmailActions: 'email-events',
    MessageRunDetails: 'mrd.message-run-details',
    Posts: 'mrd.posts',
    Promotions: 'mrd.promotions',
  },
  UserEvents: 'user-events-*',
}

export const AggFieldNames = {
  DeliveryCount: 'delivery_count',
  DocumentCount: 'doc_count',
  Engagement: 'engagement',
  KnowledgeTier: 'knowledge_tier',
  TopArticleClicks: 'top_article_clicks',
  TopSourceClicks: 'top_source_clicks',
  TopTerms: 'top_terms',
  TotalClickCount: 'total_click_count',
  TotalCount: 'total_count',
  TotalOpenCount: 'total_open_count',
  TotalTagCount: 'total_tags',
  Unique: 'unique',
  UniqueClickCount: 'unique_click_count',
  UniqueCount: 'unique_count',
  UniqueOpenCount: 'unique_open_count',
  UniqueTagCount: 'unique_tags',
}

export const DocumentFieldNames = {
  CategoryType: 'category_type',
  ClickedURL: 'clicked_url',
  Community: 'community_identifier',
  CommunityPersonGuid: 'community_person_guid',
  CommunityPersonId: 'community_person_id',
  CommunityPromotionId: 'community_promotion_id',
  CommunitySystemId: 'community_system_id',
  Created: 'created',
  Deliveries: 'deliveries',
  EffectiveDate: 'effective_date',
  EventName: 'event_name',
  EventTimestamp: 'event_timestamp',
  Id: 'id',
  IncludeInReports: 'include_in_reports',
  IsPromotion: 'is_promotion',
  IsSubjectPost: 'is_subject_post',
  IssueId: 'issue_id',
  MessageSendDate: 'message_send_date',
  MessageType: 'message_type',
  Name: 'name',
  NormalizedClickUrl: 'normalized_click_url',
  PersonGuid: 'person_guid',
  PostId: 'post_id',
  PostSubscriptionId: 'post_subscription_id',
  PostType: 'post_type',
  SessionId: 'sessionId',
  SiteName: 'site_name',
  Source: 'source',
  SourceIdentifier: 'source_identifier',
  SourceName: 'source_name',
  SubscriptionType: 'subscription_type',
  SuspectClick: 'suspect_click',
  Text: 'text',
  Tier: 'tier',
  Title: 'title',
  TotalClicks: 'total_clicks',
  TotalOpens: 'total_opens',
  TotalTags: 'total_tags',
  URL: 'url',
  UniqueClicks: 'unique_clicks',
  UniqueOpens: 'unique_opens',
  UniqueTags: 'unique_tags',
  UserAgent: 'user_agent',
}

export const EmailActionFieldSegments = {
  Click: 'click',
  Delievered: 'delivered',
  Open: 'open',
}

export const Intervals = {
  Day: 'day',
  Month: 'month',
  Week: 'week',
}

const LastMonthStart = 'now-1M/M'
const LastMonthEnd = 'now/M'

const LastWeekStart = 'now-1w/w'
const LastWeekEnd = 'now/w'

const Now = 'now'
const OneDayAgo = 'now-1d'

const YesterdayEnd = 'now/d'

const PastDayStart = 'now-1d/d'
const PastMonthStart = 'now-1M/d'
const PastWeekStart = 'now-1w/d'
const PastYearStart = 'now-1y/d'

const TodayStart = 'now/d'

export const DateRanges = {
  LastMonth: `${LastMonthStart}|${LastMonthEnd}`,
  LastWeek: `${LastWeekStart}|${LastWeekEnd}`,
  PastDay: `${OneDayAgo}|${Now}`,
  PastMonth: `${PastMonthStart}|${YesterdayEnd}`,
  PastWeek: `${PastWeekStart}|${YesterdayEnd}`,
  PastYear: `${PastYearStart}|${YesterdayEnd}`,
  Today: `${TodayStart}|${Now}`,
  Yesterday: `${PastDayStart}|${YesterdayEnd}`,
}

export const asMoment = (searchDateString: string): Moment.Moment => {
  const now = Moment()
  switch (searchDateString) {
    case LastMonthStart:
      return now.subtract(1, 'month').startOf('month')
    case LastMonthEnd:
      return now.subtract(1, 'month').endOf('month')
    case LastWeekStart:
      return now.subtract(7, 'day').startOf('week')
    case LastWeekEnd:
      return now.subtract(7, 'day').endOf('week')
    case OneDayAgo:
      return now.subtract(1, 'day')
    case YesterdayEnd:
      return now.subtract(1, 'day').endOf('day')
    case PastDayStart:
      return now.subtract(1, 'day').startOf('day')
    case PastMonthStart:
      return now.subtract(1, 'month').startOf('day')
    case PastWeekStart:
      return now.subtract(7, 'day').startOf('day')
    case PastYearStart:
      return now.subtract(1, 'year').startOf('day')
    case Now:
    default:
      return now
  }
}

export const NEWSBRIEF_MESSAGE = 'NewsbriefMessage'



// WEBPACK FOOTER //
// ./src/elasticsearch/constants.ts